// src/utils/loadChartImages.ts

const modules = import.meta.glob('@/assets/images/echartImg/*.png', {
  eager: true,
  import: 'default'
})

const imageMap: Record<string, string> = {}

for (const path in modules) {
  const match = path.match(/\/([^/]+)\.png$/) // 提取文件名
  if (match) {
    const name = match[1] // 文件名（不含扩展名）
    imageMap[name] = modules[path] as string
  }
}

export default imageMap
